import type { StatusTone } from '~/components/ui';
import type { TelemetryStatus } from '~/modules/query/ai/types';

// Completed is healthy, Error is broken, Throttled/Blocked stopped it, Abandoned is a neutral close, Active is in progress.
export const TELEMETRY_STATUS_TONES: Record<TelemetryStatus, StatusTone> = {
  Completed: 'success',
  Abandoned: 'neutral',
  Active: 'brand',
  Error: 'error',
  Throttled: 'warning',
  Blocked: 'warning',
};

export const telemetryStatus = (status: TelemetryStatus): { label: string; tone: StatusTone } => ({
  label: status,
  tone: TELEMETRY_STATUS_TONES[status],
});
